import { storiesOf } from '@storybook/vue';
import { withKnobs, text, boolean, select, number, object } from '@storybook/addon-knobs';
import { EventBus } from '@/main/eventBus';
import { PageMode } from '@/main/utils/pageMode';


const stories = storiesOf('Components/DMS/Form', module);
const g = { v: 'Validace', d: 'Default', m: 'Mask' };

stories
	.addDecorator(withKnobs)
	.add('Input', () => ({
		template: `
		<dms-form :model="$data" :rules="rules">
			<dms-input v-bind="$props" validationProperty="value" :value.sync="value" />
			<span>Vysledna hodnota: {{value}}</span>
		</dms-form>
		`,
		data() {
			return {
				value: null,
			};
		},
		props: {
			type: {
				default: select('Typ', { Text: 'text', 'E-mail': 'email', Heslo: 'password' }, 'text', g.d),
			},
			showLabel: {
				default: boolean('Zobrazit label', true, g.d),
			},
			label: {
				default: text('Label', 'Jméno', g.d),
			},
			placeholder: {
				default: text('Placeholder', 'Vaše jméno', g.d),
			},
			isRequired: {
				default: boolean('Povinné pole', true, g.d),
			},
			disabled: {
				default: boolean('Disabled', false, g.d),
			},
			min: {
				default: number('Minimální délka', 5, {}, g.v),
			},
			max: {
				default: number('Maximální délka', 15, {}, g.v),
			},
			mask: { default: text('Maska', undefined, g.m) },
			masked: { default: boolean('Masked', false, g.m) },
			tokens: { default: object('Tokens', undefined, g.m) },
		},
		computed: {
			rules() {
				return {
					value: [
						{
							min: this.min, max: this.max, message: `Délka musí být ${this.min} až ${this.max}.`, trigger: 'blur',
						},
						{
							required: this.isRequired, trigger: ['change', 'blur'],
						},
					],
				};
			},
		},
		mounted() {
			EventBus.$emit('Mode', PageMode.EDIT);
		},
	}))
	.add('Textarea', () => ({
		template: `
		<dms-form :model="$data" :rules="rules">
			<dms-input v-bind="$props" type="textarea" validationProperty="value" :value.sync="value" />
		</dms-form>
		`,
		data() {
			return {
				value: null,
			};
		},
		props: {
			rows: {
				default: number('Počet řádků', 4, {}, g.d),
			},
			showLabel: {
				default: boolean('Zobrazit label', true, g.d),
			},
			label: {
				default: text('Label', 'Jméno', g.d),
			},
			placeholder: {
				default: text('Placeholder', 'Vaše jméno', g.d),
			},
			isRequired: {
				default: boolean('Povinné pole', true, g.d),
			},
			disabled: {
				default: boolean('Disabled', false, g.d),
			},
			min: {
				default: number('Minimální délka', 5, {}, g.v),
			},
			max: {
				default: number('Maximální délka', 15, {}, g.v),
			},
		},
		computed: {
			rules() {
				return {
					value: [
						{
							min: this.min, max: this.max, message: `Délka musí být ${this.min} až ${this.max}.`, trigger: 'blur',
						},
						{
							required: this.isRequired, trigger: ['change', 'blur'],
						},
					],
				};
			},
		},
		mounted() {
			EventBus.$emit('Mode', PageMode.EDIT);
		},
	}));
